import { FC, SyntheticEvent, useEffect } from "react";
import { useParams } from "react-router-dom";

import { Box, Button, Chip, Typography } from "@mui/material";
import dayjs from "dayjs";

import { Translate } from "@/components/Application/Translate";
import { useSaveLiveTagValue } from "@/components/Live/API/LiveMutations";
import { IListenerTagRow } from "@/components/Procedures/Checklist/utils/Types";

import { AlertConfirmStepOverride } from "@/helpers/alerts/AlertConfirm";

import { UpdateProcedureDetailStepStatusRequest } from "@/model/Procedure/UpdateProcedureDetailStepStatusRequest";
import { SavedLiveTagRequest } from "@/model/SATOSLive/Settings/SavedTagValue";

import { UpdateProcedureDetailStepState } from "@/service/ProcedureMutations";
import { RouteParams } from "@/service/Utilities";

export const ListenerTagRow: FC<IListenerTagRow> = (props) => {
	const { listenerTag, step, activeSchemeId, isLast, liveTagStatuses, values } =
		props;
	const { id } = useParams<RouteParams>();

	const updateProcedureDetailStepState = UpdateProcedureDetailStepState();
	const saveLiveTagValue = useSaveLiveTagValue();

	const currentLiveTagStatus = liveTagStatuses[listenerTag.Tag];
	const currentLiveTagValue = values[listenerTag.Tag];
	useEffect(() => {}, [step, currentLiveTagStatus, liveTagStatuses]);

	const currentValue =
		!Number.isNaN(listenerTag.SavedTagValue) && listenerTag.SavedTagValue
			? listenerTag.SavedTagValue
			: !Number.isNaN(currentLiveTagValue) && currentLiveTagValue !== undefined
				? currentLiveTagValue
				: "-";

	const description = `${listenerTag?.Name} Live: ${currentValue}`;

	const SaveStatusAndValue = async () => {
		const request: UpdateProcedureDetailStepStatusRequest = {
			ArchiveType: "Status",
			StepId: props.step.Id,
			ProcedureId: +id,
			File: null,
			SchemeId: props.activeSchemeId,
			IsOverridden: true,
			Status: 1,
			Metadata: { ...props.step, Status: 0 },
		};

		await updateProcedureDetailStepState(request);

		if (currentLiveTagValue !== undefined) {
			const saveTagRequest: SavedLiveTagRequest = {
				StepId: props.step.Id,
				ProcedureId: +id,
				SchemeId: props.activeSchemeId,
				SavedTagValue: currentLiveTagValue,
				Tag: listenerTag?.Tag,
				TagId: listenerTag?.Id,
			};

			await saveLiveTagValue(saveTagRequest);
		}
	};

	const handleOverride = (e: SyntheticEvent) => {
		e.preventDefault();

		AlertConfirmStepOverride(SaveStatusAndValue);
	};

	return (
		<Box sx={{ display: "flex", gap: "3rem", overflow: "visible" }}>
			<Box
				sx={{
					textAlign: "center",
				}}
			>
				<Chip
					label={
						<>
							<Box
								sx={{
									borderRadius: "50%",
								}}
							></Box>
							{description}
						</>
					}
					sx={{
						display: "flex",
						justifyContent: "space-between",
						verticalAlign: "center",
						width: "fit-content",
						transition: ".2s all ease-in-out",
						position: "relative",
						overflow: "hidden",
						...currentLiveTagStatus?.container,
						"&:before": currentLiveTagStatus?.pulseAnimation,
					}}
				/>
				{!Number.isNaN(listenerTag?.SavedTagValue) &&
				listenerTag.SavedTagValue ? (
					<Typography variant="caption">
						Value is from:{" "}
						{dayjs(listenerTag?.SavedTagTimestamp).format("DD/MM/YY  HH:mm")}
					</Typography>
				) : step.IsOverridden ? (
					<Typography variant="caption">
						<Translate String="Checklist.Step.Overridden">
							Step was overridden
						</Translate>
					</Typography>
				) : null}
			</Box>

			{isLast && !step.Status && (
				<Box>
					<Button
						variant="outlined"
						color="warning"
						size="small"
						onClick={handleOverride}
						sx={{
							height: "30px",
						}}
					>
						<Translate String="Checklist.Step.Override">
							Override step
						</Translate>
					</Button>
				</Box>
			)}
		</Box>
	);
};
